// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jHESzBclGQSDdH3B_jVA {
  padding: 0.5rem;
  width: 260px;
}

.NGRyPCh6rjSauWMQcFfS button {
  justify-content: center;
  margin-top: 0.5rem;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/widen-library/admin/src/components/FilterBody/FilterBody.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".container {\n  padding: 0.5rem;\n  width: 260px;\n}\n\n.apply-button-container button {\n  justify-content: center;\n  margin-top: 0.5rem;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `jHESzBclGQSDdH3B_jVA`,
	"apply-button-container": `NGRyPCh6rjSauWMQcFfS`
};
export default ___CSS_LOADER_EXPORT___;
